const deleteLogsSortObj
 = (
    state = {},
    action: {
      type: "SET_DELETE_LOG_FILTER_SORT";
      payload: any;
    }
  ) => {
    switch (action.type) {
      case "SET_DELETE_LOG_FILTER_SORT":
        return { ...action.payload };
  
      default:
        return state;
    }
  };
  
  export default deleteLogsSortObj
  ;